import styled from "styled-components";

interface IContainer {
	$isDiscount: boolean;
}

export const Container = styled.span<IContainer>`
	color: ${({ $isDiscount, theme }) => ($isDiscount ? theme.green : theme.red)};
	font-weight: normal;
	white-space: nowrap;
	margin: 0 0 0 0.4rem;

	> .MuiSvgIcon-root {
		rotate: ${({ $isDiscount }) => ($isDiscount ? "180deg" : "0deg")};
		margin: -0.2rem 0 0 0;
	}
`;
